import React from 'react';

const GreyNoiseFullIPAdapterSummary = () => (
  <dl>
    <dt>API Token</dt>
    <dd>******</dd>
  </dl>
);

export default GreyNoiseFullIPAdapterSummary;
